import { FlexSpace } from 'components/base'
import styled from 'styled-components'

export const InputContent = styled(FlexSpace)`
  height: 40px;
  gap: 10px;
  margin-bottom: 10px;
  align-items: center;
`
